import { createSlice } from "@reduxjs/toolkit";
import {
  fetchVendorById,
  fetchVendorItems,
  fetchVendorsBySector,
  SearchVendorItems,
} from "./VendorThunks";

const initialState = {
  items: [],
  vendorsBySector: [],
  loading: false,
  error: null,
};

const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
      })
      .addCase(fetchVendorItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchVendorById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedVendor = action.payload;
      })
      .addCase(fetchVendorById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchVendorsBySector.pending, (state) => {
        state.status = "loading";
      })  
      .addCase(fetchVendorsBySector.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vendorsBySector = action.payload;
      })
      .addCase(fetchVendorsBySector.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(SearchVendorItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(SearchVendorItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data || [];
      })
      .addCase(SearchVendorItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch vendors";
      });
  },
});

export default vendorSlice.reducer;
